// extracted by mini-css-extract-plugin
export default {"card":"SZ-z","carouselContainer":"TZ-z","carouselContent":"UZ-z"};